import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { storyApi } from 'apis/story/storyApis';
import { ISupportLanguage } from 'utils/types/storyTypes';
import arrowUp from 'utils/icon/icon_arrow-up-blue.svg';
import arrowDown from 'utils/icon/icon_arrow-down-blue.svg';
import SelectStyled from 'components/SelectStyled';
/**
 * * 다국어 셀렉 박스
 */

interface IProps {
  onChange: (e: any) => void;
  value: string;
}
const LocalizingSelect = ({ onChange, value }: IProps) => {
  const [supportLangList, setSupportLangList] = useState<
    ISupportLanguage[] | null
  >(null);
  const fetchSupportLangListData = async () => {
    const res = await storyApi.supportLang();
    setSupportLangList(res);
  };

  useEffect(() => {
    fetchSupportLangListData();
  }, []);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleDropdownVisibleChange = (open) => {
    setIsOpen(open);
  };

  return (
    <SelectWrapper>
      <p className='selectText' style={{ paddingLeft: '10px' }}>
        작품 언어 :{' '}
      </p>

      <SelectStyled
        bordered={false}
        defaultValue={value}
        suffixIcon={<img src={isOpen ? arrowUp : arrowDown} alt='arrow' />}
        style={{ width: 'auto' }}
        onChange={(value) => onChange(value)}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        options={supportLangList?.map((v, i) => {
          return {
            value: v.code,
            label: v.code_name,
          };
        })}
      />
    </SelectWrapper>
  );
};

export default LocalizingSelect;

const SelectWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: ${theme.fontWeights.normal};
  font-size: ${theme.fontSizes.normal};
  margin-right: 30px;
  .selectText {
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    line-height: 24px;
    letter-spacing: 0.2px;
    margin-right: 5px;
  }
`;
